import de from './de.json'

export default {
    ...de,
}


// WEBPACK FOOTER //
// ./src/i18n/de-DE/de.js